import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import {
  MAX_LOGOS_PERCENTAGE,
  intervalTime,
  transitionTime,
} from '../../../../config/setup/setup';

const CarouselArrow = dynamic(
  () => import('../carousel-common/CarouselArrow'),
  {
    ssr: false,
  },
);

const CompanyCarousel = ({ deal }) => {
  return (
    <>
      <Carousel
        centerMode
        centerSlidePercentage={MAX_LOGOS_PERCENTAGE}
        className="module__logos"
        emulateTouch
        infiniteLoop
        interval={intervalTime}
        renderArrowNext={(onClickHandler, hasNext, label) => (
          <CarouselArrow
            label={label}
            onClickHandler={onClickHandler}
            orientation="next"
          />
        )}
        renderArrowPrev={(onClickHandler, hasPrevious, label) => (
          <CarouselArrow
            label={label}
            onClickHandler={onClickHandler}
            orientation="prev"
          />
        )}
        renderIndicator={null}
        renderThumbs={() => null}
        showStatus={false}
        swipeable
        transitionTime={transitionTime}
      >
        {deal}
      </Carousel>
      <style global jsx>{`
        .module__logos .carousel .slide {
          background-color: transparent;
        }
        .module__logos .flickity-prev-next-button {
          height: 34px;
          width: 24px;
          opacity: 0.5;
          margin-top: -17px;
        }
        .module__logos:hover .flickity-prev-next-button {
          opacity: 0.75;
        }
      `}</style>
      <style global jsx>{`
        .module__logos .carousel .slide img {
          width: 160px;
        }
      `}</style>
    </>
  );
};

CompanyCarousel.propTypes = {
  deal: PropTypes.array.isRequired,
};

export default CompanyCarousel;
